export default function setter(value, parent) {
  return parent.cpf || parent.cnpj;
}
